import type { Category } from "@/constants/categories";

type BeverageProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const bev = "https://images.unsplash.com/photo-1701055941822-bec7e28a65f9?w=400&q=80";
const energy = "https://images.unsplash.com/photo-1622543925917-763c34d8a31e?w=400&q=80";
const water = "https://images.unsplash.com/photo-1548839140-29a749f1cf4d?w=400&q=80";
const sparkling = "https://images.unsplash.com/photo-1527281400683-1aae23717569?w=400&q=80";
const soda = "https://images.unsplash.com/photo-1581636625402-29b45824ccd3?w=400&q=80";

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
  image: string,
): BeverageProduct => ({
  id,
  name,
  categorySlug: "beverages",
  brand,
  unit,
  price,
  image,
});

export const BEVERAGE_PRODUCTS: BeverageProduct[] = [
  // Prime Hydration
  item("bev-prime-meta-moon", "Prime Hydration Meta Moon", "Prime", "500ml", 4.99, bev),
  item("bev-prime-strawberry", "Prime Hydration Strawberry", "Prime", "500ml", 4.99, bev),
  item("bev-prime-x", "Prime Hydration X", "Prime", "500ml", 4.99, bev),
  item("bev-prime-ice-pop", "Prime Ice Pop Chill", "Prime", "500ml", 4.99, bev),
  item("bev-prime-ice-orange", "Prime Ice Orange", "Prime", "500ml", 4.99, bev),
  item("bev-prime-pop", "Prime Pop", "Prime", "500ml", 4.99, bev),
  item("bev-prime-grapes-chill", "Prime Grapes Chill", "Prime", "500ml", 4.99, bev),
  item("bev-prime-red", "Prime Red", "Prime", "500ml", 4.99, bev),
  item("bev-prime-strawberry-watermelon", "Prime Strawberry Watermelon", "Prime", "500ml", 4.99, bev),
  item("bev-prime-ufc", "Prime UFC", "Prime", "500ml", 4.99, bev),
  item("bev-prime-tropical-punch", "Prime Hydration Tropical Punch", "Prime", "500ml", 4.99, bev),
  item("bev-prime-blue-raspberry", "Prime Hydration Blue Raspberry", "Prime", "500ml", 4.99, bev),
  item("bev-prime-grape", "Prime Hydration Grape", "Prime", "500ml", 4.99, bev),

  // Pure Heaven Sparkling
  item("bev-ph-mango-grape", "Pure Heaven Sparkling Mango & White Grape", "Pure Heaven", "750ml", 5.49, sparkling),
  item("bev-ph-banana-grape", "Pure Heaven Sparkling Banana & White Grape", "Pure Heaven", "750ml", 5.49, sparkling),
  item("bev-ph-peach", "Pure Heaven Sparkling Peach", "Pure Heaven", "750ml", 5.49, sparkling),
  item("bev-ph-grape-strawberry", "Pure Heaven Sparkling White Grape & Strawberry", "Pure Heaven", "750ml", 5.49, sparkling),
  item("bev-ph-red-grape", "Pure Heaven Sparkling Red Grape", "Pure Heaven", "750ml", 5.49, sparkling),

  // Red Bull
  item("bev-red-bull-250", "Red Bull", "Red Bull", "250ml", 3.49, energy),
  item("bev-red-bull-blue", "Red Bull Blue Edition", "Red Bull", "250ml", 3.49, energy),

  // San Pellegrino
  item("bev-sp-orange-pomegranate", "San Pellegrino Orange & Pomegranate", "San Pellegrino", "330ml", 2.99, sparkling),
  item("bev-sp-aranciata", "San Pellegrino Aranciata Orange", "San Pellegrino", "330ml", 2.99, sparkling),
  item("bev-sp-aranciata-rossa", "San Pellegrino Aranciata Rossa", "San Pellegrino", "330ml", 2.99, sparkling),
  item("bev-sp-limonata", "San Pellegrino Limonata", "San Pellegrino", "330ml", 2.99, sparkling),
  item("bev-sp-water-250", "San Pellegrino Water Glass", "San Pellegrino", "250ml", 2.49, water),
  item("bev-sp-water-500", "San Pellegrino Water Glass", "San Pellegrino", "500ml", 3.49, water),
  item("bev-sp-water-750", "San Pellegrino Water Glass", "San Pellegrino", "750ml", 4.49, water),

  // Warrior
  item("bev-warrior", "Warrior Energy Drink", "Warrior", "500ml", 3.99, energy),

  // Dr Pepper
  item("bev-dr-pepper", "Dr Pepper Classic", "Dr Pepper", "355ml", 2.49, soda),

  // Evian
  item("bev-evian-12x15", "Evian Natural Spring Water", "Evian", "12 x 1.5L", 24.99, water),
  item("bev-evian-24x500", "Evian Natural Spring Water", "Evian", "24 x 500ml", 29.99, water),
  item("bev-evian-15", "Evian Natural Spring Water", "Evian", "1.5L", 3.49, water),
  item("bev-evian-500", "Evian Natural Spring Water", "Evian", "500ml", 2.49, water),
  item("bev-evian-330", "Evian Natural Spring Water", "Evian", "330ml", 1.99, water),

  // Fiji
  item("bev-fiji-12x1", "Fiji Natural Artesian Water", "Fiji", "12 x 1L", 34.99, water),
  item("bev-fiji-24x500", "Fiji Natural Artesian Water", "Fiji", "24 x 500ml", 39.99, water),

  // Monster Energy
  item("bev-monster-classic", "Monster Energy Classic", "Monster", "500ml", 3.99, energy),
  item("bev-monster-mango-loco", "Monster Mango Loco", "Monster", "500ml", 3.99, energy),
  item("bev-monster-assault", "Monster Assault", "Monster", "500ml", 3.99, energy),
  item("bev-monster-doctor", "Monster The Doctor", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-paradise", "Monster Ultra Paradise", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-violet", "Monster Ultra Violet", "Monster", "500ml", 3.99, energy),
  item("bev-monster-khaotic", "Monster Khaotic Juice", "Monster", "500ml", 3.99, energy),
  item("bev-monster-lewis-hamilton", "Monster Lewis Hamilton", "Monster", "500ml", 3.99, energy),
  item("bev-monster-pipeline-punch", "Monster Pipeline Punch", "Monster", "500ml", 3.99, energy),
  item("bev-monster-pacific-punch", "Monster Pacific Punch", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-rosa", "Monster Ultra Rosa", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-fiesta", "Monster Ultra Fiesta", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-gold", "Monster Ultra Gold", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-white", "Monster Ultra White", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-blue", "Monster Ultra Blue", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-watermelon", "Monster Ultra Watermelon", "Monster", "500ml", 3.99, energy),
  item("bev-monster-ultra-strawberry", "Monster Ultra Strawberry Dreams", "Monster", "500ml", 3.99, energy),
  item("bev-monster-mule", "Monster Mule Ginger Brew", "Monster", "500ml", 3.99, energy),

  // Perrier
  item("bev-perrier-10x250", "Perrier Sparkling Natural Mineral Water", "Perrier", "10 x 250ml", 14.99, sparkling),
  item("bev-perrier-24x330", "Perrier Sparkling Natural Mineral Water", "Perrier", "24 x 330ml", 32.99, sparkling),
];
